import React from "react";
import Helper from "./../../utils/helper"

function ExportFile(props) {
  return (
    <div style={{ display: 'none' }}>
      <table
        className="collapse-border"
        id={"export-orders"}
        border={1}
        data-cols-width="10, 30, 30, 40, 40, 40, 40, 40, 40, 40, 40, 40, 40"
      >
        <thead style={{ fontSize: "13" }}>
          <tr>
            <th
              data-b-a-c="FFFFFFFF"
              colSpan={13}
              data-f-name={"Arial"}
              data-f-sz={"18"}
              data-a-wrap={true}
              data-a-h={"center"}
              data-b-a-s={"solid"}
              data-f-bold={true}
            >
              Danh sách đơn
            </th>
          </tr>
          <tr>
            <th
              data-f-name={"Arial"}
              data-f-sz={"13"}
              data-a-h={"center"}
              data-b-a-s={"thin"}
              data-f-bold={true}
              data-a-v={"middle"}
            >
              STT
            </th>
            <th
              data-f-name={"Arial"}
              data-f-sz={"13"}
              data-a-h={"center"}
              data-b-a-s={"thin"}
              data-a-v={"middle"}
              data-f-bold={true}
              data-a-wrap={true}
            >
              Mã đơn
            </th>
            <th
              data-f-name={"Arial"}
              data-f-sz={"13"}
              data-a-h={"center"}
              data-b-a-s={"thin"}
              data-a-v={"middle"}
              data-f-bold={true}
              data-a-wrap={false}

            >
              Mã giỏ hàng
            </th>
            <th
              data-f-name={"Arial"}
              data-f-sz={"13"}
              data-a-h={"center"}
              data-b-a-s={"thin"}
              data-a-v={"middle"}
              data-f-bold={true}
              data-a-wrap={false}
            >
              Chủ hợp đồng
            </th>
            <th
              data-f-name={"Arial"}
              data-f-sz={"13"}
              data-a-h={"center"}
              data-b-a-s={"thin"}
              data-a-v={"middle"}
              data-f-bold={true}
            >
              Số điện thoại chủ hợp đồng
            </th>
            <th
              data-f-name={"Arial"}
              data-f-sz={"13"}
              data-a-h={"center"}
              data-b-a-s={"thin"}
              data-a-v={"middle"}
              data-f-bold={true}
            >
              Email chủ hợp đồng
            </th>
            <th
              data-f-name={"Arial"}
              data-f-sz={"13"}
              data-a-h={"center"}
              data-b-a-s={"thin"}
              data-a-v={"middle"}
              data-f-bold={true}
            >
              CCCD/Hộ chiếu chủ hợp đồng
            </th>
            <th
              data-f-name={"Arial"}
              data-f-sz={"13"}
              data-a-h={"center"}
              data-b-a-s={"thin"}
              data-a-v={"middle"}
              data-f-bold={true}
            >
              Danh sách người được bảo hiểm
            </th>
            <th
              data-f-name={"Arial"}
              data-f-sz={"13"}
              data-a-h={"center"}
              data-b-a-s={"thin"}
              data-a-v={"middle"}
              data-f-bold={true}
            >
              Sản phẩm
            </th>
            <th
              data-f-name={"Arial"}
              data-f-sz={"13"}
              data-a-h={"center"}
              data-b-a-s={"thin"}
              data-a-v={"middle"}
              data-f-bold={true}
            >
              Gói sản phẩm
            </th>
            <th
              data-f-name={"Arial"}
              data-f-sz={"13"}
              data-a-h={"center"}
              data-b-a-s={"thin"}
              data-a-v={"middle"}
              data-f-bold={true}
            >
              Phí bảo hiểm
            </th>
            <th
              data-f-name={"Arial"}
              data-f-sz={"13"}
              data-a-h={"center"}
              data-b-a-s={"thin"}
              data-a-v={"middle"}
              data-f-bold={true}
            >
              Thời gian thanh toán
            </th>
            <th
              data-f-name={"Arial"}
              data-f-sz={"13"}
              data-a-h={"center"}
              data-b-a-s={"thin"}
              data-a-v={"middle"}
              data-f-bold={true}
            >
              Trạng thái
            </th>
          </tr>
        </thead>
        <tbody style={{ fontSize: "13" }}>
          {(props?.data || [])?.map((item, index) => {
            return (
              <tr style={{ fontSize: "13" }}>
                <th
                  data-f-name={"Arial"}
                  data-f-sz={"13"}
                  data-b-a-s={"thin"}
                  data-a-h={"center"}
                >
                  {index + 1}
                </th>
                <th data-a-h={"center"} data-f-name={"Arial"} data-f-sz={"13"} data-b-a-s={"thin"}>
                  {item?.orderCode}
                </th>
                <th data-a-h={"center"} data-f-name={"Arial"} data-f-sz={"13"} data-b-a-s={"thin"}>
                  {item?.cartCode}
                </th>
                <th data-a-h={"center"} data-f-name={"Arial"} data-f-sz={"13"} data-b-a-s={"thin"}>
                  {Helper.capitalize(item?.buyerName)}
                </th>
                <th data-a-h={"center"} data-f-name={"Arial"} data-f-sz={"13"} data-b-a-s={"thin"}>
                  {item?.buyerPhone}
                </th>
                <th data-a-h={"center"} data-f-name={"Arial"} data-f-sz={"13"} data-b-a-s={"thin"}>
                  {item?.buyerEmail}
                </th>
                <th data-a-h={"center"} data-f-name={"Arial"} data-f-sz={"13"} data-b-a-s={"thin"}>
                  {item?.buyerPrivateId}
                </th>
                <th data-a-h={"center"} data-f-name={"Arial"} data-f-sz={"13"} data-b-a-s={"thin"}>
                  {item?.listInsuredPeople}
                </th>
                <th data-a-h={"center"} data-f-name={"Arial"} data-f-sz={"13"} data-b-a-s={"thin"}>
                  {item?.productTitle}
                </th>
                <th data-a-h={"center"} data-f-name={"Arial"} data-f-sz={"13"} data-b-a-s={"thin"}>
                  {item?.packageName}
                </th>
                <th data-a-h={"center"} data-f-name={"Arial"} data-f-sz={"13"} data-b-a-s={"thin"}>
                  {item?.fees}
                </th>
                <th data-a-h={"center"} data-f-name={"Arial"} data-f-sz={"13"} data-b-a-s={"thin"}>
                  {item?.paymentDate}
                </th>
                <th data-a-h={"center"} data-f-name={"Arial"} data-f-sz={"13"} data-b-a-s={"thin"}>
                  {item?.statusTitle}
                </th>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}

export default React.memo(ExportFile);
